import {
    ACCOUNT_ITEM_TREATMENTS,
    ACCOUNT_ITEM_MY_TICKETS,
    ACCOUNT_ITEM_MANAGE_EVENTS,
    ACCOUNT_ITEM_USER_SETTINGS,
} from '%evp_theme/brandbook/account/accountMenu';
import { pickForHighContrast } from '../highContrastSx';

function symbolTreatment(item) {
    const { icon, iconColor } = ACCOUNT_ITEM_TREATMENTS[item];

    return Object.freeze({ icon: icon.symbol, iconColor });
}

const MY_TICKETS_TREATMENT = symbolTreatment(ACCOUNT_ITEM_MY_TICKETS);
const MANAGE_EVENTS_TREATMENT = symbolTreatment(ACCOUNT_ITEM_MANAGE_EVENTS);
const USER_SETTINGS_TREATMENT = symbolTreatment(ACCOUNT_ITEM_USER_SETTINGS);

function destinationIconColor(iconColor) {
    return pickForHighContrast('text.primary', iconColor);
}

export {
    destinationIconColor,
    MY_TICKETS_TREATMENT,
    MANAGE_EVENTS_TREATMENT,
    USER_SETTINGS_TREATMENT,
};
